import { ReactElement } from 'react';
import { StyledDetailsPanel } from './styles';
import { OrderDetailsI } from '@app/healthcheck/order/types';
import OrderDetails from './order';
import PersonalDetails from './personal';

interface PersonProps {
  data: OrderDetailsI;
  handleEditOpenPersonal: () => void;
  handleEditOpenOrder: () => void;
  isOrderStatusDone?: boolean;
}

const DetailsPanelDesktop = ({
  data,
  handleEditOpenPersonal,
  handleEditOpenOrder,
  isOrderStatusDone,
}: PersonProps): ReactElement => {
  return (
    <StyledDetailsPanel>
      <OrderDetails
        isOrderStatusDone={isOrderStatusDone}
        handleEditOpenOrder={handleEditOpenOrder}
        data={data}
      />
      <PersonalDetails
        handleEditOpenPersonal={handleEditOpenPersonal}
        data={data}
      />
    </StyledDetailsPanel>
  );
};

export default DetailsPanelDesktop;
